import { registerBackNavigationHook } from '~/shared/lib'

import { isAuthFlowRoute } from './pinGate'

function extractPathFromHistoryUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null
  }

  return url.split('?')[0]?.split('#')[0] ?? url
}

export function registerAuthRouteBackNavigation() {
  registerBackNavigationHook({
    shouldForceFallback: ({ backUrl }) => {
      const path = extractPathFromHistoryUrl(backUrl)
      return path != null && isAuthFlowRoute(path)
    },
  })
}
